export default [
    {
        path: '/website-product-tags',
        props: true,
        component: () => import('@/views/WebsiteProduct/Tag'),
    },

];
